import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Box, Stack, Heading, Text } from "braid-design-system";
import { JDVLayout } from "./styles/components/JDVLayout/JDVLayout.mjs";
import { JobDetailsPreview } from "./styles/components/JobDetailsPreview/JobDetailsPreview.mjs";
import { JobDetailsView, useJobDetailsProps } from "./styles/components/JobDetailsView/JobDetailsView.mjs";
const paragraph = () => /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
  /* @__PURE__ */ jsx(Box, { background: "neutralLight", borderRadius: "small", width: "full", children: /* @__PURE__ */ jsx(Text, { children: " " }) }),
  /* @__PURE__ */ jsx(Box, { background: "neutralLight", borderRadius: "small", width: "full", children: /* @__PURE__ */ jsx(Text, { children: " " }) }),
  /* @__PURE__ */ jsx(Box, { background: "neutralLight", borderRadius: "small", width: "full", children: /* @__PURE__ */ jsx(Text, { children: " " }) }),
  /* @__PURE__ */ jsx(
    Box,
    {
      background: "neutralLight",
      borderRadius: "small",
      style: { width: "160px", maxWidth: "100%" },
      children: /* @__PURE__ */ jsx(Text, { children: " " })
    }
  )
] });
const JobDetailsMockup = ({
  highlightApplyButton = true,
  showMainContent = true,
  ...props
}) => {
  const applyButtonBackgroundColour = highlightApplyButton ? "brandAccent" : "neutralLight";
  return /* @__PURE__ */ jsx(
    JDVLayout,
    {
      ...props,
      applyAction: /* @__PURE__ */ jsx(
        Box,
        {
          background: applyButtonBackgroundColour,
          borderRadius: "standard",
          height: "touchable",
          children: /* @__PURE__ */ jsx("div", { style: { width: "142px" } })
        }
      ),
      saveAction: /* @__PURE__ */ jsx(
        Box,
        {
          background: "neutralLight",
          borderRadius: "standard",
          height: "touchable",
          children: /* @__PURE__ */ jsx("div", { style: { width: "120px" } })
        }
      ),
      header: /* @__PURE__ */ jsxs(Stack, { space: { mobile: "small", tablet: "medium" }, children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            background: "neutralLight",
            borderRadius: "small",
            style: { width: "380px", maxWidth: "100%" },
            children: /* @__PURE__ */ jsx(Heading, { component: "span", level: "1", children: " " })
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            background: "neutralLight",
            borderRadius: "small",
            style: { width: "250px", maxWidth: "100%" },
            children: /* @__PURE__ */ jsx(Text, { size: "large", children: " " })
          }
        )
      ] }),
      headerAdditional: /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            background: "neutralLight",
            borderRadius: "small",
            style: { width: "205px", maxWidth: "100%" },
            children: /* @__PURE__ */ jsx(Text, { children: " " })
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            background: "neutralLight",
            borderRadius: "small",
            style: { width: "190px", maxWidth: "100%" },
            children: /* @__PURE__ */ jsx(Text, { children: " " })
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            background: "neutralLight",
            borderRadius: "small",
            style: { width: "220px", maxWidth: "100%" },
            children: /* @__PURE__ */ jsx(Text, { children: " " })
          }
        )
      ] }) }),
      mainContent: showMainContent && /* @__PURE__ */ jsx(Stack, { space: "large", children: [1, 1, 1].map(() => paragraph()) }),
      menu: /* @__PURE__ */ jsx("span", {}),
      jobTitle: "",
      companyName: ""
    }
  );
};
const JOB_DISPLAY_TYPE_QUERY_KEY = "type";
export {
  JOB_DISPLAY_TYPE_QUERY_KEY,
  JobDetailsMockup,
  JobDetailsPreview,
  JobDetailsView,
  useJobDetailsProps
};
